import axios from "axios"
// const token=window.location.search.toString()
// const tokenString=token.slice(6)
// console.log(tokenString)


const lawService = {}
lawService.authUser = (code) => {
    const config = {
        method: "GET",
        url:`https://inheritguard.onrender.com/api/oauth/token/${code}`,
        data: null,
        crossdomain: true,
        header: { "Content-Type": "application/json" },
    };
    return axios(config)
};

//lawService.authUser("b8JoFpv4xfj-k8j9qlmocGAbZcZn_OOL2GmEjiwWhMU")
	// .then((r)=>{onAuthorizationSuccess(r)})
  // .catch((e)=>{onAuthorizationFail(e)})

lawService.markPayment= async (id)=>{
    try{
      const config={
        url:`https://inheritguard.onrender.com/api/v1/prospects/markPayment/${id}`,
        data:{
           "custom_fields": [
                {
                    "id": "459565",
                    "value": true
                }
            ]
        },
        method:"get"
      }
     
    const testo= await axios(config)
    console.log(testo)
    }
    catch(error){
        //res.status(500).json({error})
        
    }
  }
  lawService.getMatterByEmail= async (email)=>{
   const config={
        url:`https://inheritguard.onrender.com/api/v1/prospects/find_by_email/${email}`,
        // url:`http://localhost:5000/api/v1/prospects/find_by_email/${email}`,
        method:"get"
      }
     
    return axios(config)
  
     
  }
 lawService.getAttorneyById=async(id)=>{
  const config={
    url:`https://inheritguard.onrender.com/api/v1/users/${id}`,
    method:"get"
  }
 
  const apiRes= await axios(config)
  const fName=apiRes.data.data.attributes.first_name
  const lName=apiRes.data.data.attributes.last_name
  let attorneyName=`${fName} ${lName}`
  return attorneyName
}
lawService.getAttorneyEmailById=async(id)=>{
  const config={
    url:`https://inheritguard.onrender.com/api/v1/users/${id}`,
    method:"get"
  }
 
  const apiRes= await axios(config)
  const email=apiRes.data.data.attributes.email
  return email
}
lawService.pushCustomQuants=async(id,wealthNumber,RLTSNTnumber,livingSNTNumber,SNTwRLTnumber,LLCcorpNumber,LLCcorpwWealthNumber,IDGTNumber,MAPTNumber,DAPTNumber,CRUTNumber,LAPTNumber,CMTNumber,deedNumber,assignNumber,isCustomNotary,paymentNote,actualValue,recordingNumber,isFeeWaved,deedsToBeDrafted,powerOfAttorneyJ,powerOfAttorneyI,corporateKitNumber,familyOperatingNumber,familyNonOperatingNumber,standaloneBuySellNumber,buySellBusinessNumber,irrevocableNumber,dynastyIrrevocableNumber,dynastyRevocableNumber,depositAmount,trademarkAppNumber,trademarkClassFee,affidavitNumber,bPet,cPet,wealthRestatement,bGun,sGun,gGun,moms25,basicCorp,basicLLC,basicCorpWealth,basicLLCWealth,enchancedCorp,enhancedLLC,enhancedCorpWealth,enchancedLLCWealth,advancedCorp,advancedLLC,advancedCorpWealth,advancedLLCWealth,strategyReport,nonCrisis,crisis,platFunding,premFundingAst)=>{
  const config={
url:`https://inheritguard.onrender.com/api/v1/prospects/pushCustomAmounts/${id}/${wealthNumber}/${RLTSNTnumber}/${livingSNTNumber}/${SNTwRLTnumber}/${LLCcorpNumber}/${LLCcorpwWealthNumber}/${IDGTNumber}/${MAPTNumber}/${DAPTNumber}/${CRUTNumber}/${LAPTNumber}/${CMTNumber}/${deedNumber}/${assignNumber}/${isCustomNotary}/${paymentNote}/${actualValue}/${recordingNumber}/${isFeeWaved}/${deedsToBeDrafted}/${powerOfAttorneyJ}/${powerOfAttorneyI}/${corporateKitNumber}/${familyOperatingNumber}/${familyNonOperatingNumber}/${standaloneBuySellNumber}/${buySellBusinessNumber}/${irrevocableNumber}/${dynastyIrrevocableNumber}/${dynastyRevocableNumber}/${depositAmount}/${trademarkAppNumber}/${trademarkClassFee}/${affidavitNumber}/${bPet}/${cPet}/${wealthRestatement}/${bGun}/${sGun}/${gGun}/${moms25}/${basicCorp}/${basicLLC}/${basicCorpWealth}/${basicLLCWealth}/${enchancedCorp}/${enhancedLLC}/${enhancedCorpWealth}/${enchancedLLCWealth}/${advancedCorp}/${advancedLLC}/${advancedCorpWealth}/${advancedLLCWealth}/${strategyReport}/${nonCrisis}/${crisis}/${platFunding}/${premFundingAst}`,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
  //url:`http://localhost:5000/api/v1/prospects/pushCustomAmounts/${id}/${wealthNumber}/${RLTSNTnumber}/${livingSNTNumber}/${SNTwRLTnumber}/${LLCcorpNumber}/${LLCcorpwWealthNumber}/${IDGTNumber}/${MAPTNumber}/${DAPTNumber}/${CRUTNumber}/${LAPTNumber}/${CMTNumber}/${deedNumber}/${assignNumber}/${isCustomNotary}/${paymentNote}/${actualValue}/${recordingNumber}/${isFeeWaved}/${deedsToBeDrafted}/${powerOfAttorneyJ}/${powerOfAttorneyI}/${corporateKitNumber}/${familyOperatingNumber}/${familyNonOperatingNumber}/${standaloneBuySellNumber}/${buySellBusinessNumber}/${irrevocableNumber}/${dynastyIrrevocableNumber}/${dynastyRevocableNumber}/${depositAmount}/${trademarkAppNumber}/${trademarkClassFee}/${affidavitNumber}/${bPet}/${cPet}/${wealthRestatement}/${bGun}/${sGun}/${gGun}/${moms25}/${basicCorp}/${basicLLC}/${basicCorpWealth}/${basicLLCWealth}/${enchancedCorp}/${enhancedLLC}/${enhancedCorpWealth}/${enchancedLLCWealth}/${advancedCorp}/${advancedLLC}/${advancedCorpWealth}/${advancedLLCWealth}/${strategyReport}/${nonCrisis}/${crisis}/${platFunding}/${premFundingAst}`,
    method:"get"
  }
 
  const apiRes= await axios(config)
  console.log(apiRes)
}


lawService.getAllAttorneys=async(page)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/users/getAttorneys/${page}`,
    data: null,
    crossdomain: true
};
return axios(config)
}


lawService.changeAttorney=async(matterId,attorneyId)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/updateAttorney/${matterId}/${attorneyId}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.changeAttributes=async(matterId,attributeName,attributeValue)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/updateAttributesById/${matterId}/${attributeName}/${attributeValue}`,
    //url:`http://localhost:5000/api/v1/prospects/updateAttributesById/${matterId}/${attributeName}/${attributeValue}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}


lawService.getContactById=async(id)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/contacts/getContactById/${id}`,
    //url:`http://localhost:5000/api/v1/contacts/getContactById/${id}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}


lawService.createEPUSATransaction=async(transactionObj)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/createEPUSATransaction/${transactionObj.transactable_id}/${transactionObj.payment_method}/${transactionObj.amount_cents}/${transactionObj.note}`,
    //url:`http://localhost:5000/api/v1/prospects/createEPUSATransaction/${transactionObj.transactable_id}/${transactionObj.payment_method}/${transactionObj.amount_cents}/${transactionObj.note}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createEPUSATimeEntry=async(timeEntryObj)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/createEPUSATimeEntry/${timeEntryObj.contactable_id}/${timeEntryObj.description}/${timeEntryObj.rate_flat_fee}`,
    //url:`http://localhost:5000/api/v1/prospects/createEPUSATimeEntry/${timeEntryObj.contactable_id}/${timeEntryObj.description}/${timeEntryObj.rate_flat_fee}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.updateEPUSATimeEntry=async(entryObj)=>{
  const config = {
    method: "GET",
   url:`https://inheritguard.onrender.com/api/v1/prospects/updateEPUSATimeEntry/${entryObj.timeEntryId}/${entryObj.matterId}/${entryObj.rate}`,
    //url:`http://localhost:5000/api/v1/prospects/updateEPUSATimeEntry/${entryObj.timeEntryId}/${entryObj.matterId}/${entryObj.rate}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createEPUSAContact=async(spouseObj)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/contacts/createEPUSAContact/${spouseObj.first_name}/${spouseObj.last_name}/${spouseObj.email}/${spouseObj.phone}`,
    //url:`http://localhost:5000/api/v1/contacts/createEPUSAContact/${spouseObj.first_name}/${spouseObj.last_name}/${spouseObj.email}/${spouseObj.phone}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createEPUSAMatter=async(newMatter,customFields)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/createEPUSAMatter/${encodeURIComponent(newMatter.first_name)}/${encodeURIComponent(newMatter.last_name)}/${encodeURIComponent(newMatter.email)}/${encodeURIComponent(newMatter.phone)?encodeURIComponent(newMatter.phone):null}/${encodeURIComponent(newMatter.address)?encodeURIComponent(newMatter.address):null}/${encodeURIComponent(newMatter.hobbies)?encodeURIComponent(newMatter.hobbies):null}/${encodeURIComponent(newMatter.actual_value_cents)?encodeURIComponent(newMatter.actual_value_cents):0}/${encodeURIComponent(newMatter.marital_status)?encodeURIComponent(newMatter.marital_status):null}/${encodeURIComponent(newMatter.city)?encodeURIComponent(newMatter.city):null}/${encodeURIComponent(newMatter.state)?encodeURIComponent(newMatter.state):null}/${customFields.spouseId?customFields.spouseId:"null"}/${customFields.coCounselId?customFields.coCounselId:"null"}/${encodeURIComponent(newMatter.case_title)?encodeURIComponent(newMatter.case_title):null}/${encodeURIComponent(newMatter.case_blurb)?encodeURIComponent(newMatter.case_blurb):null}/${customFields.CRUT}/${customFields.CMT}/${customFields.DAPT}/${customFields.familyGuardPlans}/${customFields.LAPT}/${customFields.SNT}/${customFields.SNTwRLT}/${customFields.LLCWealth}/${customFields.LLCCorp}/${customFields.MAPT}/${customFields.RLTwSNT}/${customFields.wealthGuardPlans}/${customFields.IDGT}/${customFields.powerOfAttorneyI}/${customFields.powerOfAttorneyJ}/${customFields.familyFoundationOperating}/${customFields.familyFoundationNonOperating}/${customFields.corporateKit}/${encodeURIComponent(customFields.llcName)?encodeURIComponent(customFields.llcName):null}/0/0/`,
   // url: `http://localhost:5000/api/v1/prospects/createEPUSAMatter/${encodeURIComponent(newMatter.first_name)}/${encodeURIComponent(newMatter.last_name)}/${encodeURIComponent(newMatter.email)?encodeURIComponent(newMatter.email):null}/${encodeURIComponent(newMatter.phone)?encodeURIComponent(newMatter.phone):null}/${encodeURIComponent(newMatter.address)?encodeURIComponent(newMatter.address):null}/${encodeURIComponent(newMatter.hobbies)?encodeURIComponent(newMatter.hobbies):null}/${encodeURIComponent(newMatter.actual_value_cents)?encodeURIComponent(newMatter.actual_value_cents):0}/${encodeURIComponent(newMatter.marital_status)?encodeURIComponent(newMatter.marital_status):null}/${encodeURIComponent(newMatter.city)?encodeURIComponent(newMatter.city):null}/${encodeURIComponent(newMatter.state)?encodeURIComponent(newMatter.state):null}/${customFields.spouseId?customFields.spouseId:"null"}/${customFields.coCounselId?customFields.coCounselId:"null"}/${encodeURIComponent(newMatter.case_title)?encodeURIComponent(newMatter.case_title):null}/${encodeURIComponent(newMatter.case_blurb)?encodeURIComponent(newMatter.case_blurb):null}/${customFields.CRUT}/${customFields.CMT}/${customFields.DAPT}/${customFields.familyGuardPlans}/${customFields.LAPT}/${customFields.SNT}/${customFields.SNTwRLT}/${customFields.LLCWealth}/${customFields.LLCCorp}/${customFields.MAPT}/${customFields.RLTwSNT}/${customFields.wealthGuardPlans}/${customFields.IDGT}/${customFields.powerOfAttorneyI}/${customFields.powerOfAttorneyJ}/${customFields.familyFoundationOperating}/${customFields.familyFoundationNonOperating}/${customFields.corporateKit}/${encodeURIComponent(customFields.llcName)?encodeURIComponent(customFields.llcName):null}/0/0/`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.submitDepositForm=async(email,first_name,simpOrCust,isMadeByClient)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/forms/submitDepositForm/${email}/${first_name}/${simpOrCust}/${isMadeByClient}`,
    //url:`http://localhost:5000/api/v1/forms/submitDepositForm/${email}/${first_name}/${simpOrCust}/${isMadeByClient}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.getAllMatterFields=async(id)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/getAllMatterFields/${id}`,
   // url:`http://localhost:5000/api/v1/prospects/getAllMatterFields/${id}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}


lawService.getEPUSAMatterByEmail= async (email)=>{
  const config={
       url:`https://inheritguard.onrender.com/api/v1/prospects/findEPUSAByEmail/${email}`,
      // url:`http://localhost:5000/api/v1/prospects/findEPUSAByEmail/${email}`,
       method:"get"
     }
    
   return axios(config)
 
    
 }


 lawService.updateEPUSAMatter=async(id,actualValue,customFields)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/updateEPUSAMatter/${id}/${customFields.coCounselId?customFields.coCounselId:null}/${actualValue}/${customFields.CRUT}/${customFields.CMT}/${customFields.DAPT}/${customFields.familyGuardPlans}/${customFields.LAPT}/${customFields.SNT}/${customFields.SNTwRLT}/${customFields.LLCWealth}/${customFields.LLCCorp}/${customFields.MAPT}/${customFields.RLTwSNT}/${customFields.wealthGuardPlans}/${customFields.IDGT}/${customFields.powerOfAttorneyI}/${customFields.powerOfAttorneyJ}/${customFields.familyFoundationOperating}/${customFields.familyFoundationNonOperating}/${customFields.corporateKit}/${encodeURIComponent(customFields.llcName)?encodeURIComponent(customFields.llcName):null}/0/0`,
   //url:`http://localhost:5000/api/v1/prospects/updateEPUSAMatter/${id}/${customFields.coCounselId?customFields.coCounselId:"null"}/${actualValue}/${customFields.CRUT}/${customFields.CMT}/${customFields.DAPT}/${customFields.familyGuardPlans}/${customFields.LAPT}/${customFields.SNT}/${customFields.SNTwRLT}/${customFields.LLCWealth}/${customFields.LLCCorp}/${customFields.MAPT}/${customFields.RLTwSNT}/${customFields.wealthGuardPlans}/${customFields.IDGT}/${customFields.powerOfAttorneyI}/${customFields.powerOfAttorneyJ}/${customFields.familyFoundationOperating}/${customFields.familyFoundationNonOperating}/${customFields.corporateKit}/${encodeURIComponent(customFields.llcName)?encodeURIComponent(customFields.llcName):null}/0/0`,
    data: null,
    crossdomain: true,
};
return axios(config)
}


lawService.getContactByPhone=async(phone)=>{

    const config = {
      url: `https://inheritguard.onrender.com/api/v1/prospects/find_by_phone/${phone}`,
      method: "get",
    };

    return axios(config)
  
}

lawService.getFinlawContactByPhone=async(phone)=>{

  const config = {
    url: `https://inheritguard.onrender.com/finapi/v1/prospects/find_by_phone/${phone}`,
    method: "get",
  };

  return axios(config)

}

lawService.getInheritGold=async(email)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/contacts/getInheritgoldStatus/${email}`,
    //url:`http://localhost:3000/api/v1/contacts/getInheritgoldStatus/${email}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}


lawService.submitEvereeForm=async(first_name,email,error)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/submitEvereeErrorForm/${first_name}/${email}/${error}`,
    //url:`http://localhost:5000/api/v1/prospects/submitEvereeErrorForm/${first_name}/${email}/${error}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.submitNote=async(matterId,note)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/submitNote/${matterId}/${encodeURIComponent(note)}`,
    //url:`http://localhost:5000/api/v1/prospects/submitNote/${matterId}/${encodeURIComponent(note)}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.getMatterById=async(matterId)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/prospects/${matterId}`,
    //url:`http://localhost:5000/api/v1/prospects/${matterId}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createCompanyContact=async(companyInfo,finOrIgn)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/businessapi/createCompanyContact/${companyInfo.companyName}/${finOrIgn}`,
    //url:`http://localhost:5000/businessapi/createCompanyContact/${companyInfo.companyName}/${finOrIgn}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}

lawService.createCompanyMatter=async(companyId,contactId,finOrIgn,fieldAgentId)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/businessapi/createCompanyMatter/${companyId}/${contactId}/${fieldAgentId}/${finOrIgn}`,
    //url:`http://localhost:5000/businessapi/createCompanyMatter/${companyId}/${contactId}/${fieldAgentId}/${finOrIgn}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}
lawService.findCompanyContact=async(email,firm)=>{
  const config = {
    method: "GET",
    url:`https://inheritguard.onrender.com/api/v1/findCompanyByEmail/${email}/${firm}`,
    //url:`http://localhost:5000/api/v1/findCompanyByEmail/${email}/${firm}`,
    data: null,
    crossdomain: true,
};
return axios(config)
}
lawService.createSnapdocsOrder=async(orderInfo)=>{
  const config = {
    method: "POST",
    url:`https://staging.snapdocs.com/mobile_notary_api/v1/orders`,
    data: null,
    crossdomain: true,
};
return axios(config)
}
lawService.pushCustomQuants2=async(requestBody)=>{
  const config={
  url:`https://inheritguard.onrender.com/api/v2/prospects/pushCustomAmounts`,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
  //url:`http://localhost:5001/api/v2/prospects/pushCustomAmounts`,
    method:"post",
    data:requestBody
  }
 
  const apiRes= await axios(config)
  console.log(apiRes)
}
// const onAuthorizationSuccess=(r)=>{
//   console.log(r)
// }

// const onAuthorizationFail=(e)=>{
//   console.log(e)
//   // alert("Authorization Failed\nYou now be redirected to log in.")
//   // window.location.href="https://app.lawmatics.com/oauth/authorize?client_id=CbWFrrdb4kZUx6mGULdvsim-0jyGdgmeZOqU7WdsA4U&redirect_uri=https://inheritguard.com/shopping-cart-wordpress-test-copy/&response_type=code"
// }

export default lawService